/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Camera_Settings_CardInputs */

const vi_grower_camera_settings_card = /** @type {(inputs: Grower_Camera_Settings_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera hộ trồng`)
};

/**

* @param {Grower_Camera_Settings_CardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_camera_settings_card = /** @type {((inputs?: Grower_Camera_Settings_CardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Camera_Settings_CardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_camera_settings_card(inputs)
});